export const HOOKS_SETTINGS = {
  DOC_TYPE: {
    EXPENSES: 'expenses',
  },
  METHOD: {
    GET: 'get',
    POST: 'post',
    PUT: 'put',
  },
};
